<div class="app-modal-title">{{data.title || 'Info'}}</div>
<div class="app-modal-content">
	<ng-container *ngTemplateOutlet="data.template"></ng-container>
</div>
<div class="app-modal-footer">
	<div class="button-group">
		<button class="button-general" md-raised-button (click)="dialogRef.close()">Ok</button>
	</div>
</div>
